import { render, staticRenderFns } from "./all-config-table.vue?vue&type=template&id=f2548a52"
import script from "./all-config-table.vue?vue&type=script&lang=ts"
export * from "./all-config-table.vue?vue&type=script&lang=ts"
import style0 from "./all-config-table.vue?vue&type=style&index=0&id=f2548a52&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports